/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/config/theme';

import { getProductTrustCardVariantStyles } from './style-helpers';
import { StyledProductTrustCardProps } from './types';

const baseStyles = css`
    border-radius: 0.8rem;
    width: 100%;
    .product-trust-card-container {
        padding: var(--layout-spacing-16);
        ${theme.typography.body_small}
        display: grid;
        grid-template:
            'icon  title' auto
            '. children' auto
            / min-content auto;
    }

    .trust-card-icon {
        grid-area: icon;
    }

    .keyline-container {
        position: relative;
    }

    .keyline {
        height: var(--layout-spacing-48);
        position: absolute;
        left: 2.8rem;
        top: calc(var(--layout-spacing-48) * -1);
        stroke-width: 0.1rem;
        stroke: #ffd167;
    }

    .product-trust-card-children {
        margin-left: var(--layout-spacing-12);
        grid-area: children;
    }

    .title {
        grid-area: title;
        margin-bottom: var(--layout-spacing-2);
        margin-left: var(--layout-spacing-12);
        ${theme.typography.body_normal_highlight};
    }

    .product-trust-card-link {
        margin-top: var(--layout-spacing-8);
        width: fit-content;
    }

    .product-protection-body {
        display: flex;
        flex-direction: column;
        gap: var(--layout-spacing-12);
    }
`;

export const styles = (props: StyledProductTrustCardProps) => css`
    ${baseStyles}
    ${getProductTrustCardVariantStyles(props.variant)}
`;
